query loginToken($locale_country: String) {
    loginToken(locale_country: $locale_country)
}
